module.exports = __webpack_public_path__ + "static/media/expertWork.7d70eaaf.pdf";